import CreatePatient from "./Create";

export default CreatePatient;
